import { Center, HStack, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const Container = HStack.withConfig({
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: '$2.5',
  space: '$5',
});

export const BadgeWrapper = Center.withConfig<{ $orange: boolean }>(p => ({
  backgroundColor: p.$orange
    ? Styles.color.alert.info.background
    : Styles.color.alert.success.background,
  minWidth: '$20',
  height: '$5',
  borderRadius: '5px',
  paddingY: '$0.5',
  paddingX: '$0',
}));

export const Badge = Text.withConfig({
  fontSize: 'xs',
  lineHeight: 'xs',
  textAlign: 'center',
  fontFamily: 'heading',
  color: Styles.color.white,
});

export const displayValueStyleProps = () => ({
  background: 'transparent',
  height: '$8',
  minWidth: '$8',
  width: '$8',
});

export const incrementorStyleProps = ({ disabled }: { disabled?: boolean }) => ({
  padding: '$0',
  borderRadius: 'full',
  borderWidth: '2',
  borderColor: theme.token(disabled ? 'icon-disabled' : 'text-default'),
  _icon: {
    size: 'xs',
    borderColor: theme.token(disabled ? 'icon-disabled' : 'text-default'),
    color: theme.token(disabled ? 'icon-disabled' : 'text-default'),
  },
});
